import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
export const Container = styled(Box)({
  height: '70vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});
export const ContentWrapper = styled(Box)({
  width: '100%',
  maxWidth: 700,
});
export const ErrorContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '32px',
  maxWidth: 500,
});
export const ErrorIconWrapper = styled(Box)({
  marginBottom: '16px',
});
